import React from "react";

const UserResetPassword = () => {
  return <></>;
};

export default UserResetPassword;
